/**
 * A tab opened before a deploy asks for JS chunks the new build no longer has.
 * One reload fetches the new index.html and lands on the same URL. A second
 * failure within RELOAD_WINDOW_MS is not retried, so a broken build cannot loop.
 */
export const RELOAD_WINDOW_MS = 30_000;
const KEY = 'cj-chunk-reload-at';

const CHUNK_ERROR_RE = /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Unable to preload CSS|ChunkLoadError|Loading chunk .* failed/i;

export function isChunkError(error: unknown): boolean {
  const msg = error instanceof Error ? `${error.name} ${error.message}` : String(error);
  return CHUNK_ERROR_RE.test(msg);
}

/** True and reloads when no reload ran in the last 30 s; false when it must not. */
export function reloadOnce(now: number = Date.now(), reload: () => void = () => window.location.reload()): boolean {
  try {
    const last = Number(window.sessionStorage.getItem(KEY));
    if (last > 0 && now - last < RELOAD_WINDOW_MS) return false;
    window.sessionStorage.setItem(KEY, String(now));
  } catch {
    // No storage (private window): the reload cannot be guarded, so do not risk a loop.
    return false;
  }
  reload();
  return true;
}

if (typeof window !== 'undefined') {
  // Vite fires this when the preload of a lazy chunk fails; its default is to rethrow into the import.
  window.addEventListener('vite:preloadError', (event) => {
    if (reloadOnce()) event.preventDefault();
  });
}
